import { defineMessages } from "@/i18n";
import en from "./en";

export const desktopScreenRecordingMessages = defineMessages(
  "desktop-screen-recording",
  en,
);
